export function formatSubscriberCount(count) {
  if (count >= 1000000) {
    // Divide by 1,000,000 and check if there's a remainder
    const millions = count / 1000000;
    return millions % 1 === 0
      ? millions.toFixed(0) + "M"
      : millions.toFixed(1) + "M";
  } else if (count >= 1000) {
    // Divide by 1,000 and check if there's a remainder
    const thousands = count / 1000;
    return thousands % 1 === 0
      ? thousands.toFixed(0) + "K"
      : thousands.toFixed(1) + "K";
  }
  // Return the count as-is if it's less than 1,000
  return count.toString();
}
